// src/config/menuConfig.js
import roboWhite from "../assets/img/robot-white.png";
import roboBlack from "../assets/img/robot-black.png";
import CadeadoBlack from "../assets/svg/cadeado-black";
import PlusIcon from "../assets/svg/plusIcon";
import GestaoIcon from "../assets/svg/gestaoIcon";
import ListIcon from "../assets/svg/listIcon";
import DispositivoIcon from "../assets/svg/dispositivoICon";
import AlertTriangleIcon from "../assets/svg/warning";

// Configuração centralizada dos botões do menu
export const menuButtons = [
  {
    id: "PLUS",
    label: "PLUS",
    page: "PLUS",
    icon: PlusIcon,
    iconProps: { className: "PlusIcon", width: "25", height: "25" },
    isLocked: false, // Sempre disponível
    className: "plus-btn",
    order: 1
  },
  {
    id: "Gestao",
    label: "Gestao",
    page: "Gestao",
    icon: GestaoIcon,
    iconProps: { 
      className: "IconeMenu", 
      width: "20", 
      height: "20",
      // Cor dinâmica baseada no estado ativo
      getDynamicProps: (isActive) => ({ fill: isActive ? "#ffffff" : "#000000" })
    },
    isLocked: false, // Sempre disponível
    order: 2
  },
  {
    id: "Chatbot",
    label: "Chatbot",
    page: "Chatbot",
    // Ícone especial que muda baseado no estado
    customIcon: (isActive) => (
      <img
        src={isActive ? roboWhite : roboBlack}
        alt="Robo"
        id="robo-icon"
      />
    ),
    isLocked: process.env.REACT_APP_CHATBOT_LOCKED === 'true',
    lockIcon: CadeadoBlack,
    order: 3
  },
  {
    id: "Registros",
    label: "Registros",
    page: "history",
    icon: ListIcon,
    iconProps: {
      className: "IconeMenu",
      width: "25",
      height: "25",
      getDynamicProps: (isActive) => ({ fill: isActive ? "#ffffff" : "#000000" })
    },
    isLocked: false, // Sempre disponível
    order: 4
  },
  {
    id: "Dispositivos",
    label: "Dispositivos",
    page: "Dispositivos",
    icon: DispositivoIcon,
    iconProps: {
      className: "IconeMenu",
      width: "20",
      height: "20",
      getDynamicProps: (isActive) => ({
        fill: isActive ? "#3dbd12" : "#ffffff",
        stroke: isActive ? "#ffffff" : "#000000"
      })
    },
    isLocked: process.env.REACT_APP_DISPOSITIVOS_LOCKED === 'true',
    lockIcon: CadeadoBlack,
    order: 5
  },
{
    id: "Monitoramento",
    label: "Monitoramento",
    page: "Monitoramento",
    icon: AlertTriangleIcon,
    iconProps: {
      className: "IconeMenu",
      width: "20",
      height: "20",
      getDynamicProps: (isActive) => ({
        fill: isActive ? "#3dbd12" : "#ffffff",
        stroke: isActive ? "#ffffff" : "#000000"
      })
    },
    isLocked: process.env.REACT_APP_MONITORAMENTO_LOCKED === 'true',
    lockIcon: CadeadoBlack,
    order: 5
  },

];

// Função para obter botões ordenados
export const getMenuButtons = () => {
  return menuButtons.sort((a, b) => a.order - b.order);
};